import axios from 'axios'

const state = () => ({
	bets: [],
  })
  
  const mutations = {
	FETCH_BETS(state, bets) {
	  state.bets = bets
	},
  }
  
  const actions = {
	async fetchBets(store) {
		
		const token =  window.localStorage.getItem("token")
			? JSON.parse(window.localStorage.getItem("token"))
			: ""
		const profile_id = JSON.parse(window.localStorage.getItem("user")).id;
			
		let payload = {
			page: "1",
			limit: "1000",
			period: "YEAR",
			product: "NORMAL",
			profile_id,
			token,
		};
		const res = await axios.post(BASE_URL + "uo/bethistory", payload);

		store.commit('FETCH_BETS', res.data.bets)
	},
  }
  
  export default {
	namespaced: true,
	state,
	mutations,
	actions,
  }